import Axios from "../../configs/axios.config";

export const createBranch = (data) =>
  Axios.post(`/workspace/branch`, data).then(
    (response) => response.data.data
  );
export const updateBranch = (data, id) =>
  Axios.put(`/workspace/branch/${id}`, data).then(
    (response) => response.data.data
  );
export const getBranchList = (data) =>
  Axios.get("/workspace/branch", { params: data }).then(
    (response) => response.data
  );
export const getBranchDetail = (id) =>
  Axios.get(`/workspace/branch/${id}`).then(
    (response) => response.data.data
  );
export const deleteBranch = (id) =>
  Axios.delete(`/workspace/branch/${id}`);
